export const colors = [
    'pink',
    'red',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'grey',
];

export const seriesMapPalette = {
    "-- unknown --": 'grey',
    "Animal Crossing": 'yellow',
    "ARMS": 'green',
    "Banjo Kazooie": 'orange',
    "Bayonetta": 'pink',
    "Breath of the Wild": 'orange',
    "Castlevania": 'purple',
    "Chibi Robo": 'grey',
    "Classic Nintendo": 'grey',
    "Donkey Kong": 'green',
    "Dragon Quest": 'purple',
    "Earthbound": 'orange',
    "F-Zero": 'blue',
    "Fatal Fury": 'red',
    "Final Fantasy": 'grey',
    "Fire Emblem": 'blue',
    "Kirby": 'pink',
    "Kid Icarus": 'green',
    "Megaman": 'blue',
    "Metal Gear Solid": 'grey',
    "Metroid": 'blue',
    "Mii": 'orange',
    "Minecraft": 'green',
    "Pac-man": 'yellow',
    "Persona": 'grey',
    "Pokemon": 'red',
    "Shovel Knight": 'yellow',
    "Sonic": 'blue',
    "Splatoon": 'orange',
    "Star Fox": 'purple',
    "Street fighter": 'red',
    "Super Mario": 'red',
    "The Legend of Zelda": 'green',
    "Wii Fit": 'blue',
    "Xenoblade": 'red',
};
